import { render, staticRenderFns } from "./NormalBox.vue?vue&type=template&id=c25ec26e&scoped=true"
import script from "./NormalBox.vue?vue&type=script&lang=js"
export * from "./NormalBox.vue?vue&type=script&lang=js"
import style0 from "./NormalBox.vue?vue&type=style&index=0&id=c25ec26e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c25ec26e",
  null
  
)

export default component.exports